// Navigation (frontend/src/components/Layout.tsx). Die Sidebar rendert dieselben
// Ziele zweimal — als Kachel (<md) und als Zeile (>=md). Beide Varianten lesen
// denselben Key, damit eine Umbenennung nicht auf einem der beiden Wegen liegen
// bleibt.
//
// Zwei Ausnahmen, die bewusst ZWEI Keys haben: die Kachel trägt für zwei Ziele
// eine kürzere Beschriftung als die Zeile (die Kachel ist ~110 px breit). Das
// ist der Bestand — ein gemeinsamer Key hätte hier einen der beiden deutschen
// Texte still geändert.
export const nav = {
  uebersicht: "Übersicht",
  gruppeAlltag: "Alltag",
  aufgaben: "Aufgaben",
  mail: "Mail",
  kalender: "Kalender",
  notizen: "Notizen",
  dokumente: "Dokumente",
  tabellen: "Tabellen",
  gruppeProjekte: "Projekte",
  projekte: "Projekte",
  gruppeStudio: "Studio",
  // Studio-SEITEN bleiben deutsch (docs/i18n.md §Scope) — nur ihre
  // Navigations-Einträge werden mitübersetzt, damit die Sidebar nicht
  // halb-englisch dasteht.
  emailAutomatisierungen: "Email-Automatisierungen",
  emailAutomatisierungenKachel: "Email-Autom.",
  claimFreigaben: "Claim-Freigaben",
  bildBibliothek: "Bild-Bibliothek",
  videoStudio: "Video Studio",
  videoStudioKachel: "Video",
  blog: "Blog",
  fragebogen: "Fragebögen",
};

export type NavKatalog = typeof nav;
